import React from 'react';
import Label from '../Label';

const StepCell = ({
  stepName
}: { stepName: string }) => <Label color="warning">{stepName}</Label>;

export default StepCell;
